var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    class: [_vm.$style.titleHeroWrapper, _vm.$style.titleHeroPadding]
  }, [_vm.title ? _c('div', {
    class: [_vm.$style.titleWrapper, _vm.titleWrapperOuterStyle, _vm.$style.titleWrapperSmall]
  }, [_c('AppTitle', {
    attrs: {
      "title": _vm.title,
      "semantic-head-level": "1"
    }
  }), _vm._v(" "), _vm._t("titleType")], 2) : _vm._e(), _vm._v(" "), _vm._t("default", null, {
    "showFilters": {
      isShowExpandedFilters: _vm.isShowExpandedFilters,
      isShowFilters: _vm.isShowFilters
    }
  }), _vm._v(" "), _vm._t("row")], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };